// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2787e5dfdf--container--dqrr5","content":"_2787e5dfdf--content--pTsli","link":"_2787e5dfdf--link--NF2nO","mobile":"_2787e5dfdf--mobile--VvGr_"};